import { useEffect } from "react";
import CheckIcon from "@mui/icons-material/Check";
import Button from "components/common/Button";
import EdgeLogo from "components/Design/EdgeLogo/EdgeLogo";
import { trackPlg } from "plg/analytics/events";
import { getBlockedCountry } from "plg/analytics/blockedCountry";

const TALENT_NETWORK_URL = "https://talent.onedge.co/sign-up";

const PERKS = ["Full-time employment with benefits", "Free Edge Edu certification before you start", "A career path with defined levels"];

/**
 * Shown instead of the sign-in card when the backend answers COUNTRY_NOT_SUPPORTED (spec §3.5b): outside the US,
 * the visitor is most likely looking for work, so the card sends them to the talent network (prototype).
 */
function CountryBlockedCard() {
  useEffect(() => {
    const ipCountry = getBlockedCountry();
    trackPlg("geo_routed", { destination: "blocked", ...(ipCountry ? { ip_country: ipCountry } : {}) });
  }, []);

  return (
    <div className="plg-geo" role="alert">
      <div className="plg-geo__logo">
        <EdgeLogo size="md" state="dark" />
      </div>
      <h1 className="plg-signup__title">Looking for work, not hiring?</h1>
      <p className="plg-signup__sub">
        This side is for businesses hiring through Edge. The talent network is where you want to be. Create one
        profile and roles come to you, with no repeat applications.
      </p>
      <ul className="plg-geo__perks">
        {PERKS.map((perk) => (
          <li key={perk}>
            <CheckIcon aria-hidden fontSize="small" />
            {perk}
          </li>
        ))}
      </ul>
      <div className="plg-geo__action">
        {/* A real link (same tab), drawn as the primary button. */}
        <Button variant="contained" size="large" label="Create your profile" href={TALENT_NETWORK_URL} onClick={undefined} />
      </div>
    </div>
  );
}

export default CountryBlockedCard;
